module.exports = __webpack_public_path__ + "static/media/yash.9a2a8f3b.jpeg";